var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8340864,3.45067776 L6.13453824,3.45067776 L6.13453824,5.17601664 C6.13453824,5.49364674 5.87705538,5.7511296 5.55942528,5.7511296 L0.57511296,5.7511296 C0.257482865,5.7511296 0,5.49364674 0,5.17601664 L0,3.45067776 L2.30045184,3.45067776 L2.30045184,3.69030816 C2.30045184,3.76970969 2.36482855,3.8340864 2.44423008,3.8340864 L3.69030816,3.8340864 C3.76970969,3.8340864 3.8340864,3.76970969 3.8340864,3.69030816 L3.8340864,3.45067776 Z M6.13453824,2.10874752 L6.13453824,3.06726912 L0,3.06726912 L0,2.10874752 C0,1.79111742 0.257482865,1.53363456 0.57511296,1.53363456 L1.53363456,1.53363456 L1.53363456,0.9585216 C1.53363456,0.640891505 1.79111742,0.38340864 2.10874752,0.38340864 L4.02579072,0.38340864 C4.34342082,0.38340864 4.60090368,0.640891505 4.60090368,0.9585216 L4.60090368,1.53363456 L5.55942528,1.53363456 C5.87705538,1.53363456 6.13453824,1.79111742 6.13453824,2.10874752 Z M3.8340864,1.15022592 L2.30045184,1.15022592 L2.30045184,1.53363456 L3.8340864,1.53363456 L3.8340864,1.15022592 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.ec3d093872ed6436190710514dfd3de9.svg";
export { ForwardRef as ReactComponent };